import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["menu"];

  toggle(event) {
    this.menuTarget.classList.toggle("hidden");

    if (!this.menuTarget.classList.contains("hidden")) {
      // Get button element and its position
      const button = event.currentTarget;
      const buttonRect = button.getBoundingClientRect();

      // Temporarily show menu to get accurate dimensions
      const menuWidth = this.menuTarget.offsetWidth || 120; // Use default if not available
      const menuHeight = this.menuTarget.offsetHeight || 200;

      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;

      // Calculate position - align menu's right edge with button's right edge, shifted 12px left
      let posX = buttonRect.right - menuWidth - 12;
      let posY = buttonRect.bottom + 4; // Small gap below button

      // Adjust if menu would go off-screen to the left
      if (posX < 0) {
        posX = 0;
      }

      // Adjust if menu would go off-screen to the right
      if (posX + menuWidth > viewportWidth) {
        posX = viewportWidth - menuWidth - 10; // Add small margin from edge
      }

      // Adjust if menu would go off-screen at the bottom
      if (posY + menuHeight > viewportHeight) {
        posY = buttonRect.top - menuHeight - 4; // Show above button if no room below
      }

      // Position the menu
      this.menuTarget.style.position = "fixed";
      this.menuTarget.style.top = `${posY}px`;
      this.menuTarget.style.left = `${posX}px`;
      this.menuTarget.style.right = "auto"; // Reset any inline right style
    }
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden");
    }
  }
}
